export default __webpack_public_path__ + "static/media/sg_asgu.d458d384.bmp";